import React from "react";

const Features = () => {
  return (
    <section className="container features section" id="features">
      <div className="row text-center g-4 align-items-stretch">
        <div className="container">
          <div className="col-lg-9 mx-auto mb-3 col-sm-12">
            <h2>Powerful Features to Grow Your Business</h2>
          </div>
          <div className="col-lg-6 col-md-9 col-9 mx-auto mb-5">
            <p>
              Experience lightning-fast, secure, and scalable connectivity for
              your eCommerce site with Fexila.
            </p>
            <p className="lead mt-5" style={{ color: "#000000" }}>
              Copy<span className="and shadow">&</span>Paste<span></span>
            </p>
          </div>
        </div>

        {/* Step 1: Copy Link */}
        <div className="col-lg-4 col-md-4 mb-4 mb-md-0 border-end">
          <div
            className="h-100 p-4 rounded"
            style={{ backgroundColor: "#ffffff" }}
          >
            <div
              className="d-inline-flex justify-content-center align-items-center mb-4"
              style={{
                width: "55px",
                height: "55px",
                backgroundColor: "#e34848",
                borderRadius: "30px",
              }}
            >
              <i
                className="bi bi-link-45deg fs-3"
                style={{ color: "#fff" }}
              ></i>
            </div>
            <h4 className="mb-3">Copy Link</h4>
            <p>
              Create products, sliders, banners, and then Click to copy the link
            </p>
          </div>
        </div>

        {/* Step 2: Use Anywhere */}
        <div className="col-lg-4 col-md-4 mb-4 mb-md-0 border-end">
          <div
            className="h-100 p-4 rounded"
            style={{ backgroundColor: "#ffffff" }}
          >
            <div
              className="d-inline-flex justify-content-center align-items-center mb-4"
              style={{
                width: "55px",
                height: "55px",
                backgroundColor: "#e34848",
                borderRadius: "30px",
              }}
            >
              <i className="bi bi-globe fs-3" style={{ color: "#fff" }}></i>
            </div>
            <h4 className="mb-3">Use Anywhere</h4>
            <p>Paste the copied link into your site using your store ID</p>
          </div>
        </div>

        {/* Step 3: Sell Anything */}
        <div className="col-lg-4 col-md-4 mb-4 mb-md-0">
          <div
            className="h-100 p-4 rounded"
            style={{ backgroundColor: "#ffffff" }}
          >
            <div
              className="d-inline-flex justify-content-center align-items-center mb-4"
              style={{
                width: "55px",
                height: "55px",
                backgroundColor: "#e34848",
                borderRadius: "30px",
              }}
            >
              <i className="bi bi-bag-check fs-3" style={{ color: "#fff" }}></i>
            </div>
            <h4 className="mb-3">Sell Anything</h4>
            <p>Start receiving orders via PayPal, Stripe, or COD.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
